import React from "react";
import {ControllerController} from "./index";
import store, {useTypedSelector} from "../../store";
import ColorWheel from "./input/ColorWheel";
import {updateController} from "../../store/nodes";

export type OutputColorController = ControllerController<{h: number, s: number, l: number}>

export const OutputControlColorWheel = (props: OutputColorController) => {
    //const [value, setValue] = useControllerValue<{h: number, s: number, l: number}>(props.id, {h: 0, s: 100, l: 50});

    const h = useTypedSelector(state => state.nodes.controllers[props.id]?.value?.h ?? 0);
    const s = useTypedSelector(state => state.nodes.controllers[props.id]?.value?.s ?? 100);
    const l = useTypedSelector(state => state.nodes.controllers[props.id]?.value?.l ?? 50);

    const lockH = useTypedSelector(state => !!state.nodes.controllers[props.id]?.value?.lockH);
    const lockS = useTypedSelector(state => !!state.nodes.controllers[props.id]?.value?.lockS);
    const lockL = useTypedSelector(state => !!state.nodes.controllers[props.id]?.value?.lockL);

    const setValue = (v: {h: number, s: number, l: number}) => {
        store.dispatch(updateController({id: props.id, state: {value: v}}));
    }

    const handleChange = (c: {s?: number, l?: number, h?: number}) => {
        let hh = c.h ?? h;
        let ss = c.s ?? s;
        let ll = c.l ?? l;
        let vv = {h: hh, s: ss, l: ll};
        props.onChange(vv);
        setValue(vv);
    }

    return <ColorWheel
        hue={h}
        saturation={s}
        lightness={l}
        lockHue={lockH}
        lockSaturation={lockS}
        lockLightness={lockL}
        onChange={handleChange}
    />
}